<div class="calendar-container">
  <mat-card *ngIf="calendar$ | async as calendarState" class="box-shadow">
    <mat-card-content>
      <div *ngIf="specifiedEmpNum" class="alert warn-alert text-center">
        ADMIN MODE - Viewing {{ specifiedEmpNum }}
      </div>
      <app-data-box
        headerTitle="Monthly Totals"
        [dataItems]="
          calendarState.response?.monthlyTotals || defaultMonthlyTotals
        "
        [helpComponent]="monthlyTotalsInfoDialog"
        class="totals"
      ></app-data-box>
      <full-calendar
        #calendar
        [options]="calendarOptions"
        [events]="calendarState.response?.events"
      ></full-calendar>
      <div class="holiday-pay" *ngIf="isHolidayPayMonth">
        <div class="color-box"></div>
        <div class="legend-label">Holiday Pay</div>
      </div>
      <div class="hi-buttons-container thin-gray-border">
        <div class="width-100 flex-center">
          <mat-slide-toggle
            [checked]="showDfps$ | async"
            (change)="onDfpToggleChanged($event)"
            color="accent"
            class="dfps-toggle"
          >
            DFPs
          </mat-slide-toggle>
        </div>
        <div class="width-100 left-divider-1 flex-center">
          <div matRipple class="text-button" (click)="onHI1Clicked()">HI1</div>
        </div>
        <div class="width-100 left-divider-1 flex-center">
          <div matRipple class="text-button" (click)="onHI2Clicked()">HI2</div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-footer>
      <div class="data-status">
        <app-data-status
          [timestamp]="calendarState.response?.timestamp"
          [isLoading]="calendarState.isLoading"
          (refresh)="onRefreshClick()"
        ></app-data-status>
      </div>
      <mat-progress-bar
        *ngIf="calendarState.isLoading"
        color="accent"
        mode="indeterminate"
        class="progress-bar-bottom"
      ></mat-progress-bar>
    </mat-card-footer>
  </mat-card>

  @if (savedFlights$ | async; as savedFlights) {
    @if (savedFlights.length > 0) {
      <mat-card class="box-shadow">
        <mat-card-header>
          <mat-card-title class="header-title">
            <mat-icon [inline]="true" class="opacity-4">push_pin</mat-icon>
            <span>Pinned Flights</span>
            <mat-icon
              [inline]="true"
              (click)="onPinnedHelpClicked()"
              color="primary"
              class="info-icon-button help-icon"
              matRipple
              >help_outline</mat-icon
            >
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-saved-flights></app-saved-flights>
        </mat-card-content>
      </mat-card>
    }
  }
</div>
